/*
*   Card Carousel Functionality
*   Custom translateX-based card carousel for Umbraco GridCards component
*   Supports responsive card counts, RTL, bullet navigation, and prev/next controls
*/

$(document).ready(function () {
    $('.card-carousel').each(function () {
        var cardCarousel = $(this);
        var orbitContainer = cardCarousel.find('.orbit-container');
        var cards = orbitContainer.find('.grid-card');
        var totalCards = cards.length;
        var visibleCards = 3;
        var activeIndex = 0;
        var isRtl = $('html').attr('dir') === 'rtl';
        // 13184 — video cards (gridCard.cshtml, .card--video). Everything guarded by this flag
        // is a no-op on every carousel without one, so those behave exactly as before.
        var hasVideo = cards.find('.card--video').length > 0;
        // 13313 — kd/mhl Grid Cards styles, switched on by the block's own Component Style (the
        // callout wrapper cBBGGridCards.cshtml renders around this carousel). Both flags are false on
        // every other carousel, which then behaves exactly as before.
        // Quote: one quote per view at every width, and the row takes the height of the quote shown.
        var oneUp = cardCarousel.parent().is('.callout.quote');
        // Thumbnails: the view renders one dot per card (old slick carousel); every dot can be
        // reached, the row stops moving once the last cards are in view.
        // PD modules cards2: the kd/mhl "Gallery" style is an old slick gallery too (a dot per card).
        var dotPerCard = cardCarousel.parent().is('.callout.thumbnails, .callout.gallery') && totalCards > 1 &&
            cardCarousel.find('.orbit-bullets button').length === totalCards;
        // PD modules cards2: old slick breakpoints, read from the viewport as slick did - the CMS count from
        // 992px, at most 3 from 768, 2 from 480, else 1. Only a theme that sets
        // --card-carousel-old-breakpoints: 1 on the callout turns it on (kd _cards2pdmod: Gallery carousels
        // and the heading-less Circle carousel); unset on every other carousel, which behaves as before.
        var oldBreakpoints = (window.getComputedStyle(cardCarousel.parent()[0])
            .getPropertyValue('--card-carousel-old-breakpoints') || '').trim() === '1';
        // 13313 centred Quote (01/10/2026, kd /register/): old slick autoplay, the next quote every
        // N ms. Only a Quote carousel reads it, and only a theme that sets --card-carousel-autoplay on
        // the callout turns it on (kd _quote13313: Light text); unset or 0 = no autoplay, as before.
        var autoplayMs = oneUp ? (parseInt(window.getComputedStyle(cardCarousel.parent()[0])
            .getPropertyValue('--card-carousel-autoplay'), 10) || 0) : 0;
        // No autoplay for anyone who asks the OS for reduced motion (PR review, WCAG 2.2.2).
        if (autoplayMs > 0 && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            autoplayMs = 0;
        }

        // Highest activeIndex: normally the first card of the last full view.
        function lastIndex() {
            return dotPerCard ? totalCards - 1 : Math.max(0, totalCards - visibleCards);
        }

        // Pause a card's player if it has been started. The iframe has no src until its play
        // button is pressed (see gridCard.cshtml), so an unplayed card is skipped. YouTube
        // players are opened with enablejsapi=1 so they take the command; Vimeo takes it as is.
        function pauseCardVideo(card) {
            $(card).find('.responsive-video--card iframe[src]').each(function () {
                var src = this.getAttribute('src') || '';
                var win = this.contentWindow;
                if (!win) { return; }
                if (src.indexOf('https://www.youtube.com/') === 0) {
                    win.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), 'https://www.youtube.com');
                } else if (src.indexOf('https://player.vimeo.com/') === 0) {
                    win.postMessage(JSON.stringify({ method: 'pause' }), 'https://player.vimeo.com');
                }
            });
        }

        // Determine visible cards based on container width and CMS value
        function updateVisibleCards() {
            var parentWidth = cardCarousel.width();
            var cmsDesktopCards = parseInt(cardCarousel.attr('data-cards-to-show-carousel')) || 3;

            if (parentWidth < 550) {
                visibleCards = 1;
            } else if (parentWidth <= 1024) {
                visibleCards = cmsDesktopCards === 1 ? 1 : 2;
            } else if (parentWidth < 1300) {
                if (cmsDesktopCards === 1) {
                    visibleCards = 2;
                } else if (cmsDesktopCards >= 2 && cmsDesktopCards <= 3) {
                    visibleCards = cmsDesktopCards;
                } else {
                    visibleCards = 4;
                }
            } else {
                if (cmsDesktopCards === 1) {
                    visibleCards = 2;
                } else {
                    var maxPossibleCards = Math.floor(parentWidth / 300);
                    visibleCards = Math.min(cmsDesktopCards, maxPossibleCards);
                }
            }
            if (oneUp) {
                visibleCards = 1;
            }
            if (oldBreakpoints) {
                var viewport = window.innerWidth;
                visibleCards = viewport < 480 ? 1 : viewport < 768 ? Math.min(cmsDesktopCards, 2) :
                    viewport < 992 ? Math.min(cmsDesktopCards, 3) : cmsDesktopCards;
            }
            return parentWidth;
        }

        // Update slide widths, translation, and navigation state
        function updateSlides() {
            var parentWidth = updateVisibleCards();
            var cardWidth = parentWidth / visibleCards;

            cards.css('width', cardWidth + 'px');
            var containerWidth = cardWidth * totalCards;
            orbitContainer.css('width', containerWidth + 'px');

            var maxIndex = lastIndex();
            if (activeIndex > maxIndex) {
                activeIndex = maxIndex;
            }
            if (activeIndex < 0) {
                activeIndex = 0;
            }
            // The first card in view: activeIndex itself, except past the last full view in a
            // dot-per-card carousel.
            var shownIndex = Math.min(activeIndex, Math.max(0, totalCards - visibleCards));

            var offset;
            if (isRtl) {
                var visibleWidth = cardWidth * visibleCards;
                var remainingWidth = containerWidth - visibleWidth;
                offset = remainingWidth - (shownIndex * cardWidth);
            } else {
                offset = -(shownIndex * cardWidth);
            }
            orbitContainer.css('transform', 'translateX(' + offset + 'px)');

            // 13313 Quote: the row is as tall as the quote in view (old slick adaptiveHeight).
            if (oneUp) {
                orbitContainer.css('height', cards.eq(shownIndex).outerHeight() + 'px');
            }

            // Force reflow for images
            orbitContainer.find('.grid-card img').each(function () {
                var img = $(this);
                if (img.complete) {
                    img.css('opacity', '0.99').css('opacity', '1');
                } else {
                    img.on('load', function () {
                        img.css('opacity', '0.99').css('opacity', '1');
                    });
                }
            });

            // Update bullet navigation active state
            cardCarousel.find('.orbit-bullets button').removeClass('is-active');
            cardCarousel.find('.orbit-bullets button').eq(activeIndex).addClass('is-active');

            // 13184 — a video that slides out of view stops, rather than playing on unseen.
            if (hasVideo) {
                cards.each(function (i) {
                    if (i < activeIndex || i >= activeIndex + visibleCards) {
                        pauseCardVideo(this);
                    }
                });
            }
        }

        if (hasVideo) {
            // 13184 — one video at a time: starting a card pauses any other card already
            // playing in this carousel. The shared handler in components.js (bound on the
            // button itself, so it runs first) has already written the src. The player then
            // joins the tab order and the accessibility tree (gridCard.cshtml keeps the empty
            // iframe out of both) and takes focus, because that handler removes the button
            // that held it.
            cardCarousel.on('click', '.video-thumbnail-overlay', function () {
                var card = $(this).closest('.grid-card')[0];
                cards.not(card).each(function () { pauseCardVideo(this); });
                var iframe = $(this).siblings('iframe')[0];
                if (iframe) {
                    iframe.removeAttribute('tabindex');
                    iframe.removeAttribute('aria-hidden');
                    iframe.focus({ preventScroll: true });
                }
            });

            // 13184 — every video card holds a play button, so Tab reaches cards that are
            // off to the side. Bring the focused card into view instead of letting the browser
            // scroll the clipped container underneath the translateX layout.
            cardCarousel.on('focusin', '.grid-card', function () {
                var i = cards.index(this);
                var maxIndex = Math.max(0, totalCards - visibleCards);
                var target = activeIndex;
                if (i < activeIndex) {
                    target = i;
                } else if (i >= activeIndex + visibleCards) {
                    target = Math.min(i - visibleCards + 1, maxIndex);
                }
                if (target !== activeIndex) {
                    activeIndex = target;
                    updateSlides();
                }
                cardCarousel.scrollLeft(0);
            });
        }

        // RTL note (ticket 11385): with `flex-direction: row-reverse` on .orbit-controls
        // the DOM "previous" button is visually on the RIGHT and the DOM "next" button
        // is visually on the LEFT. Arabic users press the RIGHT button to advance forward
        // (their reading flows right-to-left, so the next item is visually leftward).
        // To make "press right → advance" work, the DOM "previous" handler must INCREMENT
        // activeIndex in RTL (and vice versa). Without this swap, pressing the visually-
        // right button would cycle 1 → 3 → 2 → 1 instead of 1 → 2 → 3 → 1 — confirmed
        // by Matt against Dallah Saudi prod 2026-05-07.
        cardCarousel.find('.orbit-previous').on('click', function () {
            var maxIndex = lastIndex();
            if (isRtl) {
                activeIndex = activeIndex < maxIndex ? activeIndex + 1 : 0;
            } else {
                activeIndex = activeIndex > 0 ? activeIndex - 1 : maxIndex;
            }
            updateSlides();
        });

        cardCarousel.find('.orbit-next').on('click', function () {
            var maxIndex = lastIndex();
            if (isRtl) {
                activeIndex = activeIndex > 0 ? activeIndex - 1 : maxIndex;
            } else {
                activeIndex = activeIndex < maxIndex ? activeIndex + 1 : 0;
            }
            updateSlides();
        });

        // Bullet navigation
        cardCarousel.find('.orbit-bullets button').on('click', function () {
            var targetIndex = parseInt($(this).attr('data-slide'));
            var maxIndex = lastIndex();
            targetIndex = Math.min(targetIndex, maxIndex);
            activeIndex = targetIndex;
            updateSlides();
        });

        // Preload images
        orbitContainer.find('.grid-card img').each(function () {
            var img = new Image();
            img.src = $(this).attr('src');
        });

        // 13313 centred Quote autoplay: forward one quote, back to the first after the last, and not in a
        // hidden tab. The first time someone interacts with the carousel (pointer over it, focus in it, a
        // tap, a key, its dots or arrows) autoplay stops for good, so a quote never moves under a reader and
        // nobody needs a separate pause control (PR review, WCAG 2.2.2). No visible change from old.
        if (autoplayMs > 0 && totalCards > 1) {
            var autoplayTimer = window.setInterval(function () {
                if (document.hidden) { return; }
                activeIndex = activeIndex < lastIndex() ? activeIndex + 1 : 0;
                updateSlides();
            }, autoplayMs);
            var stopAutoplay = function () {
                if (autoplayTimer) {
                    window.clearInterval(autoplayTimer);
                    autoplayTimer = null;
                }
            };
            // the callout wraps the slides and their dots and arrows
            cardCarousel.parent().on('mouseenter focusin pointerdown touchstart keydown click', stopAutoplay);
        }

        // Recalculate on resize
        $(window).resize(function () {
            updateSlides();
        });

        // Initialize
        updateSlides();
    });
});
